// extracted by mini-css-extract-plugin
export default {"component":"dLTS5"};